export default __webpack_public_path__ + "static/bv-570e7b11c993af71de5213fc01f8ec9a.svg";